<template>
  <div class="my" :class="{ 'my not-expanded': !expanded }">
    <header class="my-header">
      <span
        v-if="result !== ''"
        @click="deleteValue"
        class="my-header-icon-remove filter-trash cursor_pointer"
      >
        <mdicon name="trash-can-outline" size="18" />
      </span>
      <p @click="toggleCardState" class="my-header-title pl-1">
        <span
          class="text-primary pr-1"
          :class="{ 'mr-4': result !== '' }"
          v-b-tooltip.hover
          :title="header.search_scope"
        >
          <mdicon
            v-if="header.search_scope"
            name="information"
            class="information-icon"
            size="20"
          />
          <mdicon v-else name="checkbox-blank-circle-outline" size="20" />
        </span>
        <span class="pr-1">
          {{ header.key_filter_caption }}
        </span>
      </p>
      <a @click="toggleCardState" class="my-header-icon">
        <span class="icon">
          <i class="fa fa-angle-up"></i>
        </span>
      </a>
    </header>
    <div v-if="isLoading" class="text-center m-2 p-2">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <div v-if="!isLoading" class="my-content">
      <div v-if="expanded" class="content">
        <div class="m-2">
          <b-form-input
            class="col-12"
            v-if="items && items.length > 10"
            type="text"
            v-model="search"
            :placeholder="$lang.search.place_holder"
          >
          </b-form-input>
        </div>
        <div class="p-2">
          <b-form-group class="text-left">
            <b-form-checkbox
              v-for="item in filteredList"
              :key="item.id"
              :value="item.id"
              name="flavour"
              @change.native="selected"
              v-model="result"
              unchecked-value=""
            >
              {{ item.caption }}
            </b-form-checkbox>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { pathOr } from "ramda";
import { generateApiUrl, renderEumOptions } from "@/shared/utils";

export default {
  props: {
    expandAll: {
      type: Boolean,
      default: false,
    },
    header: {
      type: Object,
      default: null,
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      expanded: false,
      search: null,
      items: [],
      isLoading: false,
      result: this.value,
    };
  },
  computed: {
    filteredList() {
      if (this.search) {
        return (
          this.items &&
          this.items.filter((item) => {
            return item && item.caption.includes(this.search);
          })
        );
      } else {
        return this.items;
      }
    },
  },
  watch: {
    result(newValue) {
      this.result = newValue;
    },
  },
  created() {
    this.$on("closeAll", this.closeAll);
  },
  methods: {
    pathOr,
    generateApiUrl,
    renderEumOptions,
    deleteValue() {
      this.result = "";
      this.$emit("selected", this.result, this.header.key_service);
      this.expanded = false;
    },
    toggleCardState() {
      this.expanded = !this.expanded;
      if (this.expanded && this.items.length == 0) this.getFilter();
    },
    closeAll() {
      this.expanded = false;
    },
    clearAllData() {
      this.restult = "";
      this.closeAll();
    },
    selected() {
      this.$emit("selected", this.result, this.header.key_service);
    },
    async getFilter() {
      try {
        this.isLoading = true;
        const queryString = pathOr({}, ["params"], this.header);
        const keyFilterName = pathOr(null, ["key_filter_name"], this.header);
        const moduleName = pathOr("public", ["module"], this.header);
        const isEnum = pathOr(false, ["is_enum"], this.header);
        const url =
          moduleName === "public"
            ? generateApiUrl(
                ["resources", "filter"],
                [keyFilterName],
                queryString
              )
            : generateApiUrl(
                ["resources", "filter_module"],
                [moduleName, keyFilterName],
                queryString
              );

        if (isEnum) {
          this.items = renderEumOptions(keyFilterName, true);
        } else {
          const response = await this.$httpService.get(url);
          this.items = pathOr([], ["data", "data"], response);
        }
        this.expanded = true;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
